import {NavLeaf} from "../base/nav-leaf";
import '../styles/route-styles.css'

import * as contextControls from './components/route-context'
import * as buttonControls from './components/route-buttons';

import 'leaflet.polylinemeasure/Leaflet.PolylineMeasure'
import 'leaflet.polylinemeasure/Leaflet.PolylineMeasure.css'

import {eventBus} from "@/main";

export class RouteLeafControls extends NavLeaf {
    wpControl = null
    moveControl = null
    nogoControl = null
    drawControl = null
    clearControl = null
    сheckSafetyControl = null
    weatherText = null
    nogoText = null
    makeNavRouteControl = null;

    isUKCmode = false

    isShowMapManu = true
    isCheckSafetyControlFired = false

    isDrawNoGoZonesStarted = false

    async initbasecontrols(el) {
        await super.init(el);

        contextControls.createContextButtons.call(this)

        let button = buttonControls.createClearControl.call(this)
        this.clearControl = new button

        button = buttonControls.createMakeNavRouteControl.call(this)
        this.makeNavRouteControl = new button;

        button = buttonControls.createCheckSafetyControl.call(this)
        this.сheckSafetyControl = new button

        button = buttonControls.createWPControl.call(this)
        this.wpControl = new button

        button = buttonControls.createMoveControl.call(this)
        this.moveControl = new button

        button = buttonControls.createMakeNoGoControl.call(this)
        this.map.addControl(this.nogoControl = new button)

        this.nogoText = buttonControls.createNOGOTextBox().addTo(this.map)
    }

    handleControl(control, isVisible) {
        if (!control) return;
        if (!this.map) {
            console.warn('handleControl: map is null, cannot handle control');
            return;
        }

        if (isVisible) {
            if (!control._map) {
                this.map.addControl(control);
            }
        }
        else {
            if (control._map) {
                this.map.removeControl(control);
            }
        }
    }

    refreshControls() {
        const { isGeneralRoute, isNavRoute } = this.routesStore.activeRouteTabInfo ?? {};
        const hasGeneralRoute = !!this.routesStore.generalRoute?.data;
        const hasWaypoints = !!this.waypoints.length;
        const hasMultiplePoints = this.waypoints.length > 1;

        this.removeAllControls();
        
        if (!this.map) {
            console.warn('refreshControls: map is null, cannot add controls');
            return;
        }
        
        this.map.addControl(this.nogoControl);

        this.handleControl(this.clearControl, hasWaypoints || hasGeneralRoute);

        if (isGeneralRoute)
            this.handleControl(this.makeNavRouteControl, hasGeneralRoute);

        if (isNavRoute && hasWaypoints) {
            this.handleControl(this.сheckSafetyControl, hasMultiplePoints || hasGeneralRoute);
        
            if (this.selectedWaypointIndex !== undefined)
            {
                this.map.addControl(this.wpControl)
                this.map.addControl(this.moveControl)
                eventBus.$emit('wp-control-select-wp', this.selectedWaypointIndex)
            }
        }
    }

    showControls() {
        this.refreshControls()
        this.isShowMapManu = true
        eventBus.$emit('wp-control-select-wp', this.selectedWaypointIndex)
        if (this.isCheckSafetyControlFired)
            eventBus.$emit('wp-control-toggle-check-safety', true)
    }

    removeAllControls() {
        if (!this.map) return;
        
        // Защищаем от null контролов
        if (this.clearControl) this.map.removeControl(this.clearControl);
        if (this.makeNavRouteControl) this.map.removeControl(this.makeNavRouteControl);
        if (this.сheckSafetyControl) this.map.removeControl(this.сheckSafetyControl);
        if (this.moveControl) this.map.removeControl(this.moveControl);
        if (this.wpControl) this.map.removeControl(this.wpControl);
        if (this.nogoControl) this.map.removeControl(this.nogoControl);
    }

    hideControls() {
        this.removeAllControls();
        this.isShowMapManu = false
    }
}
